<template><div><h1 id="dauerauftrag-alte-struktur-direkt-in-auftragen" tabindex="-1"><a class="header-anchor" href="#dauerauftrag-alte-struktur-direkt-in-auftragen"><span>Dauerauftrag (alte Struktur, direkt in Aufträgen)</span></a></h1>
<p>Dauerauftrag — Wiederkehrender Auftrag</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>Ein Dauerauftrag ist ein wiederkehrender Auftrag, welcher in vordefinierten Intervallen jeweils zu einem bestimmten Zeitpunkt ausgeführt wird.</p>
<p>Pfad: <code v-pre>Verkauf → Aufträge</code></p>
<h2 id="datenfelder" tabindex="-1"><a class="header-anchor" href="#datenfelder"><span>Datenfelder</span></a></h2>
<dl>
<dt>Auftrag</dt>
<dd>Auftragsnummer, eindeutig, vom System automatisch vergeben.</dd>
<dt>VaterAuf</dt>
<dd>Auftragsnummer des Vaterauftrags (Urbeleg).</dd>
<dt>V</dt>
<dd>Verarbeitungsart des Auftrags</dd>
<dt>Art</dt>
<dd>Auftragsart</dd>
<dt>erfasst</dt>
<dd>Erfassungsdatum des Auftrags (bei Folgeaufträgen: Fakturierungsdatum)</dd>
<dt>AuftGeb</dt>
<dd>Personen-ID des Auftraggebers (Rechnungsempfänger).</dd>
<dt>Name</dt>
<dd>Name, Ort des Auftraggebers</dd>
<dt>AuftrTotal</dt>
<dd>Auftragstotal: Rechnungsbetrag</dd>
<dt>D</dt>
<dd>Dauerauftrags-Status: Dieser kann geändert werden, siehe Funktionen und Details unter <a class="link" href="../../manual/trade/dauerauftraege.html" title="4. Daueraufträge (alte Struktur, direkt in Aufträgen)">Daueraufträge bearbeiten</a>
<table>
<thead>
<tr>
<th>Status</th>
<th>Beschreibung</th>
</tr>
</thead>
<tbody>
<tr>
<td>K</td>
<td>Auslieferung erfolgt, Auftrag abgeschlossen</td>
</tr>
<tr>
<td>0</td>
<td>Automatische Verlängerung</td>
</tr>
<tr>
<td>E</td>
<td>Keine automatische Verlängerung</td>
</tr>
<tr>
<td>X</td>
<td>Kein folgender Auftrag</td>
</tr>
<tr>
<td>T</td>
<td>Terminated</td>
</tr>
</tbody>
</table>
</dd>
<dt>S</dt>
<dd>Auftragsstatus. Folgende Auftragsstati sind möglich:
<table>
<thead>
<tr>
<th>Status</th>
<th>Beschreibung</th>
</tr>
</thead>
<tbody>
<tr>
<td>1</td>
<td>Auftrag erfasst</td>
</tr>
<tr>
<td>4</td>
<td>Status 4 bezeichnet Aufträge, die nicht mehr in die Fakturierung kommen. Die Gründe können sein:Vollständig retournierter AuftragVollständig abgesagter AuftragErfolgreich fakturierter Auftrag mit Vorauszahlung</td>
</tr>
<tr>
<td>5</td>
<td>Fakturierung erfolgreich (zumindest teilweise geliefert)</td>
</tr>
</tbody>
</table>
</dd>
</dl>
<h2 id="funktionen" tabindex="-1"><a class="header-anchor" href="#funktionen"><span>Funktionen</span></a></h2>
<p>Siehe <RouteLink to="/manual/trade/dauerauftraege.html" title="4. Daueraufträge (alte Struktur, direkt in Aufträgen)">Daueraufträge bearbeiten</RouteLink></p>
<h2 id="siehe-auch" tabindex="-1"><a class="header-anchor" href="#siehe-auch"><span>Siehe auch</span></a></h2>
<p><RouteLink to="/manual/trade/auftragsverwaltung.html#Auftragsverwaltung" title="1. Auftragsverwaltung">Auftragsverwaltung</RouteLink></p>
</div></template>


